<!-- Integrated Search and Summary -->
<div class="bg-gradient-to-r from-gray-50 to-slate-50 border border-gray-200 rounded-xl p-6 w-full mb-6">
  <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
    
    <!-- Search Section -->
    <div class="flex flex-col sm:flex-row items-center gap-4">
      <div class="flex flex-col items-start">
        <label for="fechaInicio" class="text-sm font-medium text-gray-700">Fecha inicio</label>
        <input
          id="fechaInicio"
          type="date"
          [(ngModel)]="fechaini"
          [disabled]="isLoading"
          class="mt-1 px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm disabled:bg-gray-100 disabled:cursor-not-allowed"
        />
      </div>

      <div class="flex flex-col items-start">
        <label for="fechaFin" class="text-sm font-medium text-gray-700">Fecha fin</label>
        <input
          id="fechaFin"
          type="date"
          [(ngModel)]="fechafin"
          [disabled]="isLoading"
          class="mt-1 px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm disabled:bg-gray-100 disabled:cursor-not-allowed"
        />
      </div>

      <div class="flex items-end h-full pt-5">
        <button
          (click)="buscarPorFechas()"
          [disabled]="isLoading"
          class="bg-blue-600 hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed text-white font-semibold py-2 px-6 rounded-lg shadow transition-colors flex items-center gap-2"
        >
          <mat-spinner *ngIf="isLoading" diameter="16" strokeWidth="2"></mat-spinner>
          <span>{{ isLoading ? 'Buscando...' : 'Buscar' }}</span>
        </button>
      </div>
    </div>

    <!-- Summary Section -->
    <div class="flex flex-col sm:flex-row items-center gap-8">
      <!-- Date Range -->
      <div class="flex flex-col items-center">
        <div class="text-gray-600 text-sm font-medium mb-1">Mostrando transacciones de</div>
        <div class="text-lg font-semibold text-gray-800">{{ getDateRange() }}</div>
      </div>

      <!-- Filtered Count -->
      <div class="flex flex-col items-center">
        <div class="text-gray-600 text-sm font-medium mb-1">{{ 'BTB.DASHBOARD.TOTAL' | translate }}</div>
        <div class="text-lg font-semibold text-gray-800">{{ filteredCount }}</div>
      </div>

      <!-- Filtered Commission -->
      <div class="flex flex-col items-center">
        <div class="text-gray-600 text-sm font-medium mb-1">Bonificación total</div>
        <div class="text-lg font-semibold text-gray-800">{{ filteredCommission | currency:'EUR' }}</div>
      </div>
    </div>
  </div>
</div>

<div class="dashboard-box p-4 w-full">
  <div class="text-lg font-semibold mb-2">{{ 'BTB.DASHBOARD.USER_TRANSACTIONS' | translate }}</div>

  <!-- Table content -->
  <app-generic-list class="w-full flex-col transition-opacity duration-300"
                    [class.opacity-50]="isLoading"
                    [class.pointer-events-none]="isLoading"
                      [items]="transactions"
                      [filterFields]="filterFields"
                      [showFilters]="true"
                      [isFiltersCollapsed]="true"
                      (filteredCount)="onFilteredCountChange($event)"
                      (filteredItemsChange)="onFilteredItemsChange($event)"
                      (activeFiltersChange)="onActiveFiltersChange($event)">
      <ng-template #tableHeaderTemplate>
        <div class="flex justify-between items-center py-2 border-b font-semibold text-gray-600">
          <span class="w-1/5">{{ 'BTB.DASHBOARD.TABLE.TYPE' | translate }}</span>
          <span class="w-1/5">{{ 'BTB.DASHBOARD.TABLE.USER_NUMBER' | translate }}</span>
          <span class="w-1/5 ">{{ 'BTB.DASHBOARD.TABLE.AMOUNT' | translate }}</span>
          <span class="w-1/5 ">{{ 'BTB.DASHBOARD.TABLE.BONUS' | translate }}</span>
          <span class="w-1/5 ">{{ 'BTB.DASHBOARD.TABLE.COMMISSION' | translate }}</span>
          <span class="w-1/5">{{ 'BTB.DASHBOARD.TABLE.DATE' | translate }}</span>
        </div>
      </ng-template>
      <ng-template #itemTemplate let-item>
        <div class="flex justify-between items-center py-2 border-b">
          <span class="w-1/5">{{ item.Tipo }}</span>
          <span class="w-1/5">{{ item.emailreferido }}</span>
          <span class="w-1/5">{{ item.monto_bruto }}</span>
          <span class="w-1/5">{{ item.monto_comision }}</span>
          <span class="w-1/5">{{ formatCommission(item) }}</span>
          <span class="w-1/5">{{ item.createdAt | dateTimeSpanish }}</span>
        </div>
      </ng-template>
      <div *ngIf="filteredCount === 0" class="text-gray-400 text-center mt-2">
        {{ 'BTB.DASHBOARD.NO_USER_TRANSACTIONS' | translate }}
      </div>
    </app-generic-list>
</div>
